import React, { Component } from 'react';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DatePicker } from "antd";

import { PERMISSION } from '../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../utils/route-auth';

import Table from '../../../components/CustomTable';
import ModalConfirmation from '../../../components/ModalConfirmation';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import moment from 'moment';
import Graph from '../../../assets/images/modalIcon/graph.png';
import dayjs from "dayjs";
import { options, optionsHistory, statusBadge, formFields } from './constant';
import Select from "react-select";

import {
    getOptimizerListAction,
    getOptimizerListRecommendationAction,
    getPaymentRelatedAccessAction
} from '../../../actions';
import Spinner from '../../../components/Spinner';
import { handleFieldError } from '../../../utils/form-validation';
import { getCurrentDateInTimeZone, getDateFromUtcToSpecificZone, getTenantTimeZone, isTenantAgency, isTenantDemoAdvertiser } from '../../../selectors';
import { executedRecommendationList, totalRecommenationList } from '../../../constants/demo/optimizerData';


const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));
const Modal = asyncRoute(() => import('../../../components/Modal'));
const Input = asyncRoute(() => import('../../../components/FormElements/Input'))

const { RangePicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            advertiserListData: [],
            confirmationOpen: false,
            confirmationInfo: '',
            currentTable: 1,
            currentTableName: 'Executed Recommendation',
            currentRecommendationData: [],
            showSpinner: true,
            optimizerAcessDetails: {},
            isSemiSuspendedOrNot: 1,
            showSuspendDiv: false,
            isPlatformManager: '',
            filterAdvertiser: [],
            filterPlatform: [],
            filterCampaign: [],
            filterRecoType: [],
            filterStatus: [],
            optionsAdvertiser: [],
            optionsPlatform: [],
            optionsCampaign: [],
            optionsRecoType: [],
            optionsStatus: [],
            // by default last 7 day filter *****************
            dateRange: {
                sdate: moment(new Date().setDate(new Date().getDate() - (this.isDemoAdvertiser ? 31 : 7))).format(
                    "YYYY-MM-DD"
                ),
                edate: moment(new Date().setDate(new Date().getDate())).format(
                    "YYYY-MM-DD"
                ),
            },
            tableOptions: optionsHistory,
            popoverVisible: false,
            form: {},
            errors: {},
            touced: {},
            searchParams: '',
            searchTimeout: null,
            IsAgency: JSON.parse(sessionStorage.getItem('IsAgency')),
            isDateMappedToData: false,

        };
    }

    // if tenant is Demo advertiser
    isDemoAdvertiser = isTenantDemoAdvertiser(this.props.tenantId)

    updateResponseListWithDates = (responseList, startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (start > end) {
            throw new Error("Start date must be earlier than or equal to end date.");
        }

        // Generate an array of dates within the range
        const generateDateRange = (start, end) => {
            const dates = [];
            let currentDate = new Date(start);
            while (currentDate <= end) {
                dates.push(new Date(currentDate).toISOString().split('T')[0]); // Format as YYYY-MM-DD
                currentDate.setDate(currentDate.getDate() + 1); // Increment by one day
            }
            return dates;
        };

        const dateRange = generateDateRange(start, end);
        // Ensure we limit the number of response list entries to the date range length
        const selectedEntries = responseList.slice(0, dateRange.length);

        // Assign dates from the range to the selected entries
        const updatedList = selectedEntries.map((entry, index) => ({
            ...entry,
            sdate: dateRange[index],
        }));
        return updatedList;
    }

    demoAdvertiserDateMapping = () => {
        if (!this.state.isDateMappedToData) {
            const customSdate = moment(new Date().setDate(new Date().getDate() - 31)).format("YYYY-MM-DD"),
                customEdate = moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD");

            const optimizerData = {};

            optimizerData.executedRecommendationList = this.updateResponseListWithDates(executedRecommendationList.responseList.recommendationList, customSdate, customEdate)
            optimizerData.totalRecommenationList = this.updateResponseListWithDates(totalRecommenationList.responseList.recommendationList, customSdate, customEdate)

            return optimizerData;
        }
    }

    async componentWillMount() {

        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        const { history, getPaymentRelatedAccessAction, tenantId, userId, authToken } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }

        // ****************optimizer Access Payment subscription realted Code starts here**********************************

        const dataLocal = JSON.parse(localStorage.getItem("PreSignInData"))
        let Isplat = dataLocal.responseList[0].tenantType
        this.setState({ isPlatformManager: Isplat })
        if (Isplat == "Platform Manager") {
            await this.historyApi();
            // await this.currentRecommendationApi();
            this.setState({ showSpinner: false })
        } else {
            // await this.AcessValidate();
            await this.historyApi();
            // await this.currentRecommendationApi();
            this.setState({ showSpinner: false })
        }

        // ****************optimizer Access Payment subscription realted Code End here*********************************

    }


    AcessValidate = async () => {
        const { tenantId, userId, authToken, getPaymentRelatedAccessAction, history } = this.props

        const { responseCode: { status }, response } = await getPaymentRelatedAccessAction({ tenantId, authToken, userId });
        let optimizerAcessDetails = {}
        let paymentAccess
        let isSemiSuspendedOrNot
        if (status.toLowerCase() == "success") {
            paymentAccess = response
            if (paymentAccess && paymentAccess.subscriptionDetails && paymentAccess.subscriptionDetails.length > 0) {

                let accessDetails = paymentAccess && paymentAccess.subscriptionDetails[0]
                isSemiSuspendedOrNot = accessDetails.atdAccessModel.status && accessDetails.atdAccessModel.status
                optimizerAcessDetails = accessDetails.atdAccessModel.accessDetailsList.find((data) => data.screenId == 2)
                // if (isSemiSuspendedOrNot == 2 || optimizerAcessDetails.type == 0) {
                //     options.actionsThead = false
                // } else {
                //     options.actionsThead = true
                // }

                // if (isSemiSuspendedOrNot == 1 || (optimizerAcessDetails && optimizerAcessDetails.type == 1) || (optimizerAcessDetails && optimizerAcessDetails.type == 2)) {
                if (isSemiSuspendedOrNot == 1) {
                    await this.historyApi();
                    await this.currentRecommendationApi();
                }
                this.setState({ optimizerAcessDetails, isSemiSuspendedOrNot })
            }
            else {
                history.push(`/${routes.mainRoute}/${routes.containers.errors}`)
            }
            this.setState({ showSuspendDiv: true })
        } else {
            history.push(`/${routes.mainRoute}/${routes.containers.errors}`)

        }


    }

    // historyApi = async () => {
    //     try {
    //         const { tenantId, authToken, userId, getOptimizerListAction } = this.props
    //         const {
    //             responseCode: { status = "" },
    //             responseList,
    //         } = await getOptimizerListAction({ tenantId, authToken, userId });
    //         if (status == "Success") {
    //             const data = responseList[0].otherRecomendations;
    //             this.setState({ historyData: data });
    //         } else {
    //             this.setState({ showSpinner: false })
    //         }
    //     }
    //     catch (err) {
    //         // console.log(err);
    //         this.setState({ showSpinner: false })
    //     }



    // }
    historyApiDataManager = (responseList) => {
        const { optionsCampaign,
            optionsRecoType,
            optionsStatus,
            optionsPlatform,
            optionsAdvertiser } = this.state;

        if (
            responseList &&
            responseList.recommendationList &&
            responseList.recommendationList.length > 0
        ) {
            if (optionsAdvertiser.length == 0 && optionsPlatform.length == 0 &&
                optionsCampaign.length == 0 && optionsRecoType.length == 0 &&
                optionsCampaign.length == 0 && optionsStatus.length == 0) {

                const campaignFilter = (
                    (responseList.filter && responseList.filter.campaigns) ||
                    []
                ).map((dataFil) => ({
                    label: dataFil.value,
                    value: dataFil.id,
                }));

                const recoFilter = (
                    (responseList.filter && responseList.filter.recoTypes) ||
                    []
                ).map((dataFil, index) => ({
                    label: dataFil,
                    value: index,
                }));

                const statusFilter = (
                    (responseList.filter && responseList.filter.status) ||
                    []
                ).map((dataFil) => ({
                    label: dataFil.value,
                    value: dataFil.id,
                }));

                const platformFilter = (
                    (responseList.filter && responseList.filter.platforms) ||
                    []
                ).map((dataFil) => ({
                    label: dataFil.value,
                    value: dataFil.id,
                }));

                const advertiserFilter = (
                    (responseList.filter && responseList.filter.advertisers) ||
                    []
                ).map((dataFil) => ({
                    label: dataFil.value,
                    value: dataFil.id,
                }));

                this.setState({
                    optionsCampaign: campaignFilter,
                    optionsRecoType: recoFilter,
                    optionsStatus: statusFilter,
                    optionsPlatform: platformFilter,
                    optionsAdvertiser: advertiserFilter,
                });
            }


            // dataRecomendations.forEach((dataReco, index) => {
            //     const findDataStatus = statusMapData.find(
            //         (dataSt) => dataSt.id == dataReco.statusId
            //     );
            //     dataRecomendations[index].statusBadge = cloneDeep(statusBadge);
            //     if (findDataStatus) {
            //         dataRecomendations[index].status = findDataStatus.value;
            //     }
            // });

            this.setState({
                historyData: responseList.recommendationList,
            });
        }
        else this.setState({
            historyData: [],
        });
    }

    generalisedFilterFunction = (responseList, sdate, edate, filterCampaign, filterAdvertiser, filterPlatform, filterRecoType, filterStatus) => {
        const cFilterSet = new Set(filterCampaign.flat().map(item => item.label));
        const aFilterSet = new Set(filterAdvertiser.flat().map(item => item.label));
        const pFilterSet = new Set(filterPlatform.flat().map(item => item.label));
        const rFilterSet = new Set(filterRecoType.flat().map(item => item.label));
        const sfilterSet = new Set(filterStatus.flat().map(item => item.value));
        if (cFilterSet.size > 0) responseList = responseList.filter(item => cFilterSet.has(item.campaignInfo))
        if (aFilterSet.size > 0) responseList = responseList.filter(item => aFilterSet.has(item.tenantName))
        if (pFilterSet.size > 0) responseList = responseList.filter(item => pFilterSet.has(item.platformName))
        if (rFilterSet.size > 0) responseList = responseList.filter(item => rFilterSet.has(item.recoType))
        if (sfilterSet.size > 0) responseList = responseList.filter(item => sfilterSet.has(item.status))
        return responseList.filter(item => item.sdate >= sdate).filter(item => item.sdate <= edate)
    }

    historyApi = async () => {
        const { tenantId, authToken, userId, getOptimizerListAction } = this.props;
        const { dateRange,
            filterCampaign = [],
            filterAdvertiser = [],
            filterPlatform = [],
            filterRecoType = [],
            filterStatus = [],
        } = this.state;

        if (this.isDemoAdvertiser) {
            if (this.state.currentTableName === 'Executed Recommendation') {
                let cloneOfExecutedRecommendationList = _.cloneDeep(executedRecommendationList);
                let modifiedDataList = this.demoAdvertiserDateMapping().executedRecommendationList;

                modifiedDataList = this.generalisedFilterFunction(modifiedDataList, dateRange.sdate, dateRange.edate, filterCampaign, filterAdvertiser, filterPlatform, filterRecoType, filterStatus)

                cloneOfExecutedRecommendationList.responseList.recommendationList = modifiedDataList;
                this.historyApiDataManager(cloneOfExecutedRecommendationList.responseList)
            }
            else {
                let cloneOfTotalRecommendationList = _.cloneDeep(totalRecommenationList);
                let modifiedDataList = this.demoAdvertiserDateMapping().totalRecommenationList;

                modifiedDataList = this.generalisedFilterFunction(modifiedDataList, dateRange.sdate, dateRange.edate, filterCampaign, filterAdvertiser, filterPlatform, filterRecoType, filterStatus)

                cloneOfTotalRecommendationList.responseList.recommendationList = modifiedDataList
                this.historyApiDataManager(cloneOfTotalRecommendationList.responseList)
            }
            return;
        }

        let params = { listhistory: "all" };
        const {
            currentTableName = "",
            statusMapData,
        } = this.state;

        // if executed/all reco then change params here ********************

        if (currentTableName == "Executed Recommendation") {
            params = { listhistory: "executed" };
        } else {
            params = { listhistory: "all" };
        }

        // payload for history api *****************************************

        const payload = {
            campaigns: filterCampaign.map((dataFil) => ({
                id: dataFil.value,
                value: dataFil.label,
            })),
            recoTypes: filterRecoType.map((dataFil) => dataFil.label),
            platforms: filterPlatform.map((dataFil) => ({
                id: dataFil.value,
                value: dataFil.label,
            })),
            status: filterStatus.map((dataFil) => ({
                id: dataFil.value,
                value: dataFil.label,
            })),
            advertiser: filterAdvertiser.map((dataFil) => ({
                id: dataFil.value,
                value: dataFil.label,
            })),
            sdate: dateRange.sdate,
            edate: dateRange.edate,
        };

        // *****************************************************************

        const {
            responseCode: { status = "" },
            responseList = {},
        } = await getOptimizerListAction({
            tenantId,
            authToken,
            userId,
            params,
            payload,
        });
        if (status == "Success") {
            this.historyApiDataManager(responseList)
        }
    };
    // currentRecommendationApi = async () => {
    //     const { tenantId, authToken, userId, getOptimizerListRecommendationAction } = this.props
    //     const {
    //         responseCode: { status = "" },
    //         responseList,
    //     } = await getOptimizerListRecommendationAction({ tenantId, authToken, userId });
    //     if (status == "Success") {
    //         const data = responseList;
    //         this.setState({ currentRecommendationData: data });
    //     }


    // }


    currentRecommendationApi = async () => {
        const { tenantId, authToken, userId, getOptimizerListRecommendationAction } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getOptimizerListRecommendationAction({ tenantId, authToken, userId });

        if (status === "Success") {
            const data = responseList;
            const uniqueData = this.removeDuplicateObjects(data, "advertiserName");
            this.setState({ currentRecommendationData: uniqueData, showSpinner: false });
        }
        else {
            this.setState({ showSpinner: false })
        }
    };

    removeDuplicateObjects = (data, key) => {
        const uniqueData = data.reduce((acc, obj) => {
            if (!acc.find((item) => item[key] === obj[key])) {
                acc.push(obj);
            }
            return acc;
        }, []);
        return uniqueData;
    };





    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };


    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };


    handleRecommedationAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'view') {
            this.setState({ viewRecommendModal: true, selectedRecommendation: row });
        }
        else if (action.type === 'accept') {
            this.setState({ acceptModal: true, selectedRecommendation: row });
        }
        else if (action.type === 'reject') {
            this.setState({ rejectModal: true, selectedRecommendation: row });
        }
    };



    handleView(row, match, history) {
        history.push(`${match.path}/${routes.optimizer.recommendations}/${row.advertiserId}`)
    }

    onRangeChange = (dates, dateStrings) => {
        if (dates) {
            this.setState(
                {
                    ...this.state,
                    dateRange: {
                        ...this.state.dateRange,
                        sdate: dateStrings[0],
                        edate: dateStrings[1],
                    },
                    filterPlatform: [],
                    filterAdvertiser: [],
                    filterCampaign: [],
                    filterRecoType: [],
                    filterStatus: [],
                    optionsAdvertiser: [],
                    optionsPlatform: [],
                    optionsCampaign: [],
                    optionsRecoType: [],
                    optionsStatus: [],
                },
                () => {
                    this.historyApi();
                }
            );
        }
    };


    resetFilter = () => {
        // code for changing table header date ********************************************

        const { currentTableName, currentTable, tableOptions } = this.state;

        let clonedTableOptions = cloneDeep(tableOptions);

        let indexForDate = clonedTableOptions.columns.findIndex(
            (option) => option.name == "executedDate"
        );

        if (indexForDate >= 0) {
            if (currentTableName == "Executed Recommendation" && currentTable == 1) {
                clonedTableOptions.columns[indexForDate].label = "Executed Date";
            }
            else {
                clonedTableOptions.columns[indexForDate].label = "Created on";
            }
        }

        // ***********************************************************************************

        const { tenantId } = this.props;
        const targetTimeZone = getTenantTimeZone(tenantId);
        const currentDate = getCurrentDateInTimeZone(targetTimeZone);

        const defaultDate = currentDate; // Example default date in YYYY-MM-DDTHH:mm:ss format
        const defaultMoment = moment(defaultDate, 'YYYY-MM-DD hh:mm:ss');
        const defaultMomentEnd = moment(defaultDate, 'YYYY-MM-DD hh:mm:ss');
        let sDate = defaultMoment.subtract(6, 'days');
        if (this.isDemoAdvertiser) sDate = defaultMoment.subtract(31, 'days')
        const eDate = defaultMomentEnd;
        const formattedSDate = sDate.format('YYYY-MM-DD');
        const formattedEDate = eDate.format('YYYY-MM-DD');

        this.setState(
            {
                dateRange: {
                    sdate: formattedSDate,
                    edate: formattedEDate,
                },
                filterPlatform: [],
                filterAdvertiser: [],
                filterCampaign: [],
                filterRecoType: [],
                filterStatus: [],
                optionsAdvertiser: [],
                optionsPlatform: [],
                optionsCampaign: [],
                optionsRecoType: [],
                optionsStatus: [],
                tableOptions: clonedTableOptions
            },
            () => {
                this.historyApi();
            }
        );
    };


    togglePopover = () => {
        const { popoverVisible } = this.state;
        this.setState({ popoverVisible: !popoverVisible })
    };


    handleChange = (e) => {
        const { form, searchTimeout } = this.state;
        const { value, name, min } = e.target;

        if (name === 'search') {
            this.setState({ searchParams: value }, () => {
                clearTimeout(searchTimeout);
                const newTimeout = setTimeout(() => {
                    this.searchCampaign();
                }, 300);
                this.setState({ searchTimeout: newTimeout });
            });
            return;
        }

        if (min) {
            value = Math.max(Number(min), Number(value));
        }
        this.setState({ ...form, [name]: value });
    };



    searchCampaign = async () => {

        let payload = {
            advertiserId: [],
            bekiCampaign: [],
            platformCampaign: [],
            status: [],
        };
        console.log("payload", payload)


        // await dispatch(campaignSearchAction({ tenantId, authToken, userId, payload, searchParams })).then((data) => {

        //     const {
        //         responseCode: { status = "" },
        //         response,
        //     } = data;

        //     if (status === "Success") {

        //         setListCampaignModal(response);
        //     } else {
        //         console.log("List data not found");
        //     }
        // })
        //     .catch((error) => {
        //         console.error(error);
        //     });
    };


    handleTouch = (e) => {
        const { errors, touched, form } = this.state;
        const { name, value } = e.target;
        const { error } = handleFieldError(form[name], formFields[name]);
        this.setState({ ...errors, [name]: value, ...touched, [name]: value })
    };

    handleFilterChange = (selected, type) => {
        if (type == "platform") {
            this.setState({ filterPlatform: selected });
        } else if (type == "recoType") {
            this.setState({ filterRecoType: selected });
        } else if (type == "status") {
            this.setState({ filterStatus: selected });
        } else if (type == "campaign") {
            this.setState({ filterCampaign: selected });
        } else if (type == "advertiser") {
            this.setState({ filterAdvertiser: selected });
        }
    };

    capitalizeWords(str) {
        return str.replace(/\b\w/g, function (char) {
            return char.toUpperCase();
        });
    }

    breakCamelCase(key) {
        return key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, function (str) { return str.toUpperCase(); });
    }


    addAdvertiserColumnToOptions(options, advertiserId) {
        // Check if the 'advertiser' column already exists
        const advertiserColumnExists = options.columns.some(col => col.name === 'tenantName');

        // If the 'advertiser' column already exists, return the options as is
        if (advertiserColumnExists) {
            return options;
        }

        // If the 'advertiser' column does not exist, add it to the options
        const optionsWithAdvertiser = { ...options };
        const advertiserColumnId = options.columns.length > 0 ? Math.max(...options.columns.map(col => col.id)) + 1 : 1;
        const advertiserColumn = {
            id: advertiserColumnId,
            name: 'tenantName',
            label: 'ADVERTISER',
            sortable: true,
            type: 'string',
            default: advertiserId,
            component: (row) => <div>{row && row.tenantName ? row.tenantName : '-'}</div>

        };

        // Insert the advertiser column at the second position
        optionsWithAdvertiser.columns.splice(1, 0, advertiserColumn);

        return optionsWithAdvertiser;
    }

    // Helper function to check if a string is a valid URL
    isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }



    render() {
        // Check conditions and add advertiser column to options
        const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));
        const advertiserId = advertiserData && advertiserData.advertiserId;
        const isAgency = isTenantAgency(this.props.tenantId);

        if (advertiserId || isAgency) {
            this.addAdvertiserColumnToOptions(options);
            this.addAdvertiserColumnToOptions(optionsHistory);
        }

        const { match, ioListAll, configurationList } = this.props;
        const { confirmationOpen, confirmationInfo, optionsList, currentTable, currentTableName, showSpinner, optimizerAcessDetails = {}, isSemiSuspendedOrNot, showSuspendDiv, isPlatformManager,
            viewRecommendModal, selectedRecommendation, dateRange,
            popoverVisible,
            form, errors, submited, touched,
            filterPlatform,
            filterAdvertiser,
            filterCampaign,
            filterRecoType,
            filterStatus,
            optionsAdvertiser,
            optionsPlatform,
            optionsCampaign,
            optionsRecoType,
            optionsStatus,
            historyData,
            IsAgency } = this.state;


        const date = new Date();
        const { tenantId } = this.props;
        const targetTimeZone = getTenantTimeZone(tenantId);
        const currentDate = getCurrentDateInTimeZone(targetTimeZone);
        const todayDate = dayjs(currentDate).format("YYYY-MM-DD");
        const time = new Date(date.getTime());

        time.setMonth(date.getMonth() + 1);
        time.setDate(0);

        const startDate = dayjs(currentDate).subtract(1, "month").startOf("month");
        const endDate = dayjs(currentDate).subtract(1, "month").endOf("month");

        const disabledDate = (current) => {
            return (
                current &&
                (current > dayjs(currentDate).endOf("day") ||
                    current <= moment(currentDate).startOf("day").subtract(3, "months"))
            );
        };

        const rangePresets = [
            {
                label: "Yesterday",
                value: [
                    dayjs(currentDate).subtract(1, "day"),
                    dayjs(currentDate).subtract(1, "day"),
                ],
            },
            {
                label: "Last 7 Days",
                value: [
                    dayjs(currentDate).subtract(6, "day"),
                    dayjs(currentDate),
                ],
            },
            {
                label: "Last 30 Days",
                value: [
                    dayjs(currentDate).subtract(30, "day"),
                    dayjs(currentDate).subtract(1, "day"),
                ],
            },
            {
                label: "This Month",
                value: [dayjs().startOf("month"), dayjs(currentDate)],
            },
            { label: "Last Month", value: [startDate, endDate] },
        ];
        let currentRecommendationData = [
            {
                "id": 1,
                "executedDate": "2024-01-04",
                "campaignName": "Campaign_Test",
                "adSetID": 11,
                "platform": "Ads",
                "recoType": "Genertive AI - Keywords",
                "currValue": "keyword1",
                "newValue": "keywordNEW",
                "status": "success",
            },
            {
                "id": 1,
                "executedDate": "2024-01-04",
                "campaignName": "Campaign_Test",
                "adSetID": 11,
                "platform": "Ads",
                "recoType": "Genertive AI - Keywords",
                "currValue": "keyword1",
                "newValue": "keywordNEW",
                "status": "success",
            },
        ]

        const clonedOptions = cloneDeep(options);
        const clonedHistoryColumns = cloneDeep(optionsHistory);

        clonedOptions.columns.forEach((dataCol) => {
            if (dataCol.name == "executedDate") {
                dataCol["component"] = (row) => row.executedDate ? moment(getDateFromUtcToSpecificZone({ date: row.executedDate, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
            }
        })

        clonedHistoryColumns.columns.forEach((dataCol) => {
            if (dataCol.name == "createdOn") {
                dataCol["component"] = (row) => row.createdOn ? moment(getDateFromUtcToSpecificZone({ date: row.createdOn, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
            }
        })


        // let historyData = [
        //     {
        //         "id": 1,
        //         "executedDate": "2024-01-04",
        //         "campaignName": "Campaign_Test",
        //         "adSetID": 11,
        //         "platform": "Ads",
        //         "recoType": "Genertive AI - Keywords",
        //         "currValue": "keyword1",
        //         "newValue": "keywordNEW",
        //         "status": "",
        //     },
        //     {
        //         "id": 1,
        //         "executedDate": "2024-01-04",
        //         "campaignName": "Campaign_Test",
        //         "adSetID": 11,
        //         "platform": "Ads",
        //         "recoType": "Genertive AI - Keywords",
        //         "currValue": "keyword1",
        //         "newValue": "keywordNEW",
        //         "status": "success",
        //     },
        // ]

        return (
            <>
                {showSpinner && <Spinner />}
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}

                <Modal open={viewRecommendModal} size='small' >
                    <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 20px 70px rgba(0, 0, 0, 0.25)', borderRadius: 10, flexDirection: 'column', justifyContent: 'flex-start', display: 'inline-flex' }}>
                        <div className='d-flex justify-content-center align-items-center p-3' style={{ background: "#F7F8FC" }}>
                            <h5 className='mb-0' style={{ fontWeight: 500 }}>Recommendation Details</h5>
                            <i className="ti ti-x" style={{ position: "absolute", right: 5, top: 10, fontSize: 25, cursor: "pointer" }} onClick={() => { this.setState({ viewRecommendModal: false }) }}></i>
                        </div>
                        <div className='row p-3'>
                            {/* <div className='col-7'> */}
                            {selectedRecommendation && typeof selectedRecommendation === 'object' ? (
                                Object.keys(selectedRecommendation).map((key, index) => (
                                    key !== "type" && key !== "id" && key != "subTypeId" && key != "status" &&
                                    <div className='col-6'>
                                        <React.Fragment key={index}>
                                            <p style={{ color: "#707B8A" }} className='mb-0'><small>{this.breakCamelCase(key)}</small></p>
                                            {/* <h6 style={{ fontWeight: 500, fontSize: 14 }}>{(key == "createdOn" || key == "executedDate") ? moment(getDateFromUtcToSpecificZone({date:selectedRecommendation[key],targetTimeZone:targetTimeZone})).format('YYYY-MM-DD') : selectedRecommendation[key]}</h6> */}
                                            <h6 style={{ fontWeight: 500, fontSize: 14, lineBreak: 'anywhere' }}>
                                                {selectedRecommendation[key] ?
                                                    (key === "createdOn" || key === "executedDate" ?
                                                        moment(getDateFromUtcToSpecificZone({ date: selectedRecommendation[key], targetTimeZone: targetTimeZone })).format('YYYY-MM-DD') :
                                                        (this.isValidUrl(selectedRecommendation[key]) ?
                                                            <a href={selectedRecommendation[key]} target="_blank" rel="noopener noreferrer">{selectedRecommendation[key]}</a> :
                                                            selectedRecommendation[key]
                                                        )
                                                    ) : ""
                                                }
                                            </h6>

                                        </React.Fragment>
                                    </div>
                                ))
                            ) : (
                                <Card>
                                    <div className='text-center'>
                                        <h5>No Data Available</h5>
                                    </div>
                                </Card>
                            )}
                            {/* Special handling for recoInfo */}
                            {selectedRecommendation && selectedRecommendation.recoInfo && (
                                <div className='col-12'>
                                    <p style={{ color: "#707B8A" }} className='mb-0'><small>{this.breakCamelCase('recoInfo')}</small></p>
                                    <div style={{ fontWeight: 500, fontSize: 14 }}>
                                        {selectedRecommendation.recoInfo.split(',').map((info, index) => (
                                            this.isValidUrl(info.trim()) ?
                                                <div className="p-1" key={index}><a href={info.trim()} target="_blank" rel="noopener noreferrer">{info.trim()}</a></div> :
                                                <div className="p-1" key={index}>{this.capitalizeWords(info.trim())}</div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {/* </div> */}
                            <div className='col-5'>
                                {/* <img style={{ width: "100%", height: "100%", objectFit:"contain" }} src={Graph} /> */}
                            </div>
                        </div>
                        <div className='d-flex justify-content-end align-items-center p-3' style={{ background: "#F7F8FC" }}>
                            <button className='btn btn-primary' onClick={() => { this.setState({ viewRecommendModal: false }) }}>
                                Close
                            </button>
                        </div>
                    </div>
                </Modal>

                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        {
                            isPlatformManager && isPlatformManager == "Platform Manager" ?
                                <>
                                    {/*  This code for platform manager (same code is below in last condtion and that code for Noramal Teanants) */}

                                    {/* <div className="row mt-3">
                                        <Card>

                                            <div className="tabs-adj optimizer-adj flex-grow-1">
                                                <ul class="nav nav-tabs customNav" role="tablist">
                                                    <li class="nav-item">
                                                        <button
                                                            type="button"
                                                            className={`${currentTable === 1 ? "nav-link active" : "nav-link"} customNavButton`}
                                                            onClick={() =>
                                                                this.setState({
                                                                    currentTableName: "Executed Recommendation",
                                                                    currentTable: 1,
                                                                })}
                                                            href="javascript:void(0);" role="tab"
                                                        >
                                                            Current Recommendation
                                                        </button>
                                                    </li>
                                                    <li class="nav-item">
                                                        <button
                                                            type="button"
                                                            className={`${currentTable === 2 ? "nav-link active" : "nav-link"} customNavButton`}
                                                            onClick={() =>
                                                                this.setState({
                                                                    currentTableName: "History",
                                                                    currentTable: 2,
                                                                })
                                                            }
                                                            href="javascript:void(0);" role="tab"
                                                        >
                                                            History
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>

                                            {
                                                currentTableName === "Executed Recommendation" ?
                                                    <div className="table-responsive mt-4">
                                                        <Table
                                                            options={options}
                                                            data={historyData || []}
                                                            handelAction={this.handleRecommedationAction}
                                                        />

                                                    </div> :
                                                    <div className="table-responsive mt-4">
                                                        <Table
                                                            options={optionsHistory}
                                                            data={historyData || []}
                                                            handelAction={this.handleRecommedationAction}
                                                        />

                                                    </div>

                                            }

                                        </Card>
                                    </div> */}

                                    <div className="row mt-3 campaign-adj ">
                                        <Card>
                                            <div className="tabs-adj optimizer-adj flex-grow-1">
                                                <ul class="nav nav-tabs customNav mx-0" role="tablist">
                                                    <li class="nav-item">
                                                        <button
                                                            type="button"
                                                            className={`${currentTable === 1 ? "nav-link active" : "nav-link"} customNavButton`}
                                                            // onClick={() =>
                                                            //     this.setState({
                                                            //         currentTableName: "Executed Recommendation",
                                                            //         currentTable: 1,
                                                            //     })}
                                                            onClick={() => {
                                                                if (currentTableName != "Executed Recommendation") {
                                                                    this.setState(
                                                                        {
                                                                            currentTableName: "Executed Recommendation",
                                                                            currentTable: 1,
                                                                            popoverVisible: false
                                                                        },
                                                                        () => {
                                                                            this.resetFilter();
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                            href="javascript:void(0);" role="tab"
                                                        >
                                                            Executed Recommendation
                                                        </button>
                                                    </li>
                                                    <li class="nav-item">
                                                        <button
                                                            type="button"
                                                            className={`${currentTable === 2 ? "nav-link active" : "nav-link"} customNavButton`}
                                                            // onClick={() =>
                                                            //     this.setState({
                                                            //         currentTableName: "History",
                                                            //         currentTable: 2,
                                                            //     })
                                                            // }
                                                            onClick={() => {
                                                                if (currentTableName != "Total Recommendations") {
                                                                    this.setState(
                                                                        {
                                                                            currentTableName: "Total Recommendations",
                                                                            currentTable: 2,
                                                                            popoverVisible: false
                                                                        },
                                                                        () => {
                                                                            this.resetFilter();
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                            href="javascript:void(0);" role="tab"
                                                        >
                                                            Total Recommendation
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>


                                            <React.Fragment>
                                                <div className='d-flex align-items-center justify-content-between my-3'>
                                                    <div className='d-flex align-items-center pl-3 position-relative'>
                                                        <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", borderRadius: 6 }} className='btn' onClick={this.togglePopover}>
                                                            <i className='ti ti-filter ti-sm'></i>
                                                            Filters
                                                        </button>
                                                        {popoverVisible && (
                                                            <div className='popover'>

                                                                <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3 mt-n3'>
                                                                    <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                                                                    <button className='close close-popover' onClick={this.togglePopover}>
                                                                        &times;
                                                                    </button>
                                                                </div>

                                                                <div className="row flex-column p-3">
                                                                    <div
                                                                        className="col-md-12 pr-0 align-items-center align-self-start mt-3 "
                                                                        style={{ position: "relative", right: "13px" }}
                                                                    >
                                                                        <label className="ml-3">Date Range:</label>
                                                                        <br />
                                                                        <div className="col-md-12" id="TrendsDateElement">
                                                                            <div className="row">
                                                                                <div className="col-md-12 pr-0">
                                                                                    <RangePicker
                                                                                        defaultValue={[
                                                                                            dayjs(dateRange.sdate, "YYYY-MM-DD"),
                                                                                            dayjs(dateRange.edate, "YYYY-MM-DD"),
                                                                                        ]}
                                                                                        presets={rangePresets}
                                                                                        onChange={this.onRangeChange}
                                                                                        style={{
                                                                                            width: "100%",
                                                                                        }}
                                                                                        value={
                                                                                            dateRange.sdate == "" &&
                                                                                                dateRange.edate == ""
                                                                                                ? ""
                                                                                                : [
                                                                                                    dayjs(
                                                                                                        dateRange.sdate,
                                                                                                        "YYYY-MM-DD"
                                                                                                    ),
                                                                                                    dayjs(
                                                                                                        dateRange.edate,
                                                                                                        "YYYY-MM-DD"
                                                                                                    ),
                                                                                                ]
                                                                                        }
                                                                                        disabledDate={disabledDate}
                                                                                        format={"YYYY-MM-DD"}
                                                                                        inputReadOnly={true}
                                                                                        allowClear={false}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <label className="ml-1 mt-3">Advertiser:</label>
                                                                        <br />
                                                                        <Select
                                                                            options={optionsAdvertiser}
                                                                            defaultValue={filterAdvertiser}
                                                                            value={filterAdvertiser}
                                                                            onChange={(selected) => {
                                                                                this.handleFilterChange(selected, "advertiser");
                                                                            }}
                                                                            className="roFilter"
                                                                            isMulti={true}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <label className="ml-1 mt-3">Platform:</label>
                                                                        <br />
                                                                        <Select
                                                                            options={optionsPlatform}
                                                                            defaultValue={filterPlatform}
                                                                            value={filterPlatform}
                                                                            onChange={(selected) => {
                                                                                this.handleFilterChange(selected, "platform");
                                                                            }}
                                                                            className="roFilter"
                                                                            isMulti={true}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <label className="ml-1 mt-3">Campaign:</label>
                                                                        <br />
                                                                        <Select
                                                                            options={optionsCampaign}
                                                                            defaultValue={filterCampaign}
                                                                            value={filterCampaign}
                                                                            onChange={(selected) => {
                                                                                this.handleFilterChange(selected, "campaign");
                                                                            }}
                                                                            className="roFilter"
                                                                            isMulti={true}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <label className="ml-1 mt-3">Reco Type:</label>
                                                                        <br />
                                                                        <Select
                                                                            options={optionsRecoType}
                                                                            defaultValue={filterRecoType}
                                                                            value={filterRecoType}
                                                                            onChange={(selected) => {
                                                                                this.handleFilterChange(selected, "recoType");
                                                                            }}
                                                                            className="roFilter"
                                                                            isMulti={true}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <label className="ml-1 mt-3">Status:</label>
                                                                        <br />
                                                                        <Select
                                                                            options={optionsStatus}
                                                                            defaultValue={filterStatus}
                                                                            value={filterStatus}
                                                                            onChange={(selected) => {
                                                                                this.handleFilterChange(selected, "status");
                                                                            }}
                                                                            className="roFilter"
                                                                            isMulti={true}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                                                        <button
                                                                            type="submit"
                                                                            class="btn btn-primary"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.historyApi();
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <i class="fa fa-check-circle"></i>Apply
                                                                        </button>
                                                                        <button
                                                                            className="btn ml-2 btn-primary"
                                                                            onClick={() => {
                                                                                this.resetFilter();
                                                                            }}
                                                                        >
                                                                            <i class="mdi mdi-replay"></i>Reset
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* <div className='d-flex align-items-center mt-3 ml-3 search-adj'>
                                                                        <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                                                                        <Input
                                                                            onChange={this.handleChange}
                                                                            onBlur={this.handleTouch}
                                                                            value={form[formFields.search.key]}
                                                                            setting={formFields[formFields.search.key]}
                                                                            error={errors[formFields.search.key]}
                                                                            submited={submited}
                                                                        // disabled={true}
                                                                        // touched={touched[formFields.search.key]}
                                                                        />
                                                                    </div> */}
                                                    </div>
                                                </div>
                                            </React.Fragment>

                                            {
                                                currentTableName === "Executed Recommendation" ?
                                                    <div className="optimiser-subsection-table campaign-list-adj table-responsive">
                                                        <Table
                                                            options={options}
                                                            data={historyData || []}
                                                            handelAction={this.handleRecommedationAction}
                                                        />

                                                    </div> :
                                                    <div className="optimiser-subsection-table campaign-list-adj table-responsive">
                                                        <Table
                                                            options={optionsHistory}
                                                            data={historyData || []}
                                                            handelAction={this.handleRecommedationAction}
                                                        />

                                                    </div>

                                            }
                                        </Card>
                                    </div>

                                </> : isSemiSuspendedOrNot !== undefined && isSemiSuspendedOrNot == 0 && showSuspendDiv ?
                                    <>
                                        <div class="alert alert-danger mt-3" role="alert">
                                            Your account is in suspended state. Hence you currently do not have access to Optimizer.
                                        </div>
                                    </> : isSemiSuspendedOrNot !== undefined && isSemiSuspendedOrNot == 2 ?
                                        <>
                                            <div class="alert alert-danger mt-3" role="alert">
                                                Your account is now in a semi-suspended state during which your account functionality will be limited. To resume services, please make the required payment.
                                                Due to semi-suspended you don't have access to this screen. In case of any queries, please feel free to reach out to our support team at  support@infomo.com
                                            </div>
                                        </> : isSemiSuspendedOrNot !== undefined && isSemiSuspendedOrNot == 1 ?
                                            <>
                                                {/*  this code for normal Tenants  */}
                                                <div className="row mt-3 campaign-adj ">
                                                    <Card>
                                                        <div className="tabs-adj optimizer-adj flex-grow-1">
                                                            <ul class="nav nav-tabs customNav mx-0" role="tablist">
                                                                <li class="nav-item">
                                                                    <button
                                                                        type="button"
                                                                        className={`${currentTable === 1 ? "nav-link active" : "nav-link"} customNavButton`}
                                                                        // onClick={() =>
                                                                        //     this.setState({
                                                                        //         currentTableName: "Executed Recommendation",
                                                                        //         currentTable: 1,
                                                                        //     })}
                                                                        onClick={() => {
                                                                            if (currentTableName != "Executed Recommendation") {
                                                                                this.setState(
                                                                                    {
                                                                                        currentTableName: "Executed Recommendation",
                                                                                        currentTable: 1,
                                                                                        popoverVisible: false
                                                                                    },
                                                                                    () => {
                                                                                        this.resetFilter();
                                                                                    }
                                                                                );
                                                                            }
                                                                        }}
                                                                        href="javascript:void(0);" role="tab"
                                                                    >
                                                                        Executed Recommendation
                                                                    </button>
                                                                </li>
                                                                <li class="nav-item">
                                                                    <button
                                                                        type="button"
                                                                        className={`${currentTable === 2 ? "nav-link active" : "nav-link"} customNavButton`}
                                                                        // onClick={() =>
                                                                        //     this.setState({
                                                                        //         currentTableName: "History",
                                                                        //         currentTable: 2,
                                                                        //     })
                                                                        // }
                                                                        onClick={() => {
                                                                            if (currentTableName != "Total Recommendations") {
                                                                                this.setState(
                                                                                    {
                                                                                        currentTableName: "Total Recommendations",
                                                                                        currentTable: 2,
                                                                                        popoverVisible: false
                                                                                    },
                                                                                    () => {
                                                                                        this.resetFilter();
                                                                                    }
                                                                                );
                                                                            }
                                                                        }}
                                                                        href="javascript:void(0);" role="tab"
                                                                    >
                                                                        Total Recommendation
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>


                                                        <React.Fragment>
                                                            <div className='d-flex align-items-center justify-content-between my-3'>
                                                                <div className='d-flex align-items-center pl-3 position-relative'>
                                                                    <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", borderRadius: 6 }} className='btn' onClick={this.togglePopover}>
                                                                        <i className='ti ti-filter ti-sm'></i>
                                                                        Filters
                                                                    </button>
                                                                    {popoverVisible && (
                                                                        <div className='popover'>

                                                                            <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3 mt-n3'>
                                                                                <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                                                                                <button className='close close-popover' onClick={this.togglePopover}>
                                                                                    &times;
                                                                                </button>
                                                                            </div>

                                                                            <div className="row flex-column p-3">
                                                                                <div
                                                                                    className="col-md-12 pr-0 align-items-center align-self-start mt-3 "
                                                                                    style={{ position: "relative", right: "13px" }}
                                                                                >
                                                                                    <label className="ml-3">Date Range:</label>
                                                                                    <br />
                                                                                    <div className="col-md-12" id="TrendsDateElement">
                                                                                        <div className="row">
                                                                                            <div className="col-md-12 pr-0">
                                                                                                <RangePicker
                                                                                                    defaultValue={[
                                                                                                        dayjs(dateRange.sdate, "YYYY-MM-DD"),
                                                                                                        dayjs(dateRange.edate, "YYYY-MM-DD"),
                                                                                                    ]}
                                                                                                    presets={rangePresets}
                                                                                                    onChange={this.onRangeChange}
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                    }}
                                                                                                    value={
                                                                                                        dateRange.sdate == "" &&
                                                                                                            dateRange.edate == ""
                                                                                                            ? ""
                                                                                                            : [
                                                                                                                dayjs(
                                                                                                                    dateRange.sdate,
                                                                                                                    "YYYY-MM-DD"
                                                                                                                ),
                                                                                                                dayjs(
                                                                                                                    dateRange.edate,
                                                                                                                    "YYYY-MM-DD"
                                                                                                                ),
                                                                                                            ]
                                                                                                    }
                                                                                                    disabledDate={disabledDate}
                                                                                                    format={"YYYY-MM-DD"}
                                                                                                    inputReadOnly={true}
                                                                                                    allowClear={false}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-12">
                                                                                    <label className="ml-1 mt-3">Advertiser:</label>
                                                                                    <br />
                                                                                    <Select
                                                                                        options={optionsAdvertiser}
                                                                                        defaultValue={filterAdvertiser}
                                                                                        value={filterAdvertiser}
                                                                                        onChange={(selected) => {
                                                                                            this.handleFilterChange(selected, "advertiser");
                                                                                        }}
                                                                                        className="roFilter"
                                                                                        isMulti={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-12">
                                                                                    <label className="ml-1 mt-3">Platform:</label>
                                                                                    <br />
                                                                                    <Select
                                                                                        options={optionsPlatform}
                                                                                        defaultValue={filterPlatform}
                                                                                        value={filterPlatform}
                                                                                        onChange={(selected) => {
                                                                                            this.handleFilterChange(selected, "platform");
                                                                                        }}
                                                                                        className="roFilter"
                                                                                        isMulti={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-12">
                                                                                    <label className="ml-1 mt-3">Campaign:</label>
                                                                                    <br />
                                                                                    <Select
                                                                                        options={optionsCampaign}
                                                                                        defaultValue={filterCampaign}
                                                                                        value={filterCampaign}
                                                                                        onChange={(selected) => {
                                                                                            this.handleFilterChange(selected, "campaign");
                                                                                        }}
                                                                                        className="roFilter"
                                                                                        isMulti={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-12">
                                                                                    <label className="ml-1 mt-3">Reco Type:</label>
                                                                                    <br />
                                                                                    <Select
                                                                                        options={optionsRecoType}
                                                                                        defaultValue={filterRecoType}
                                                                                        value={filterRecoType}
                                                                                        onChange={(selected) => {
                                                                                            this.handleFilterChange(selected, "recoType");
                                                                                        }}
                                                                                        className="roFilter"
                                                                                        isMulti={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-12">
                                                                                    <label className="ml-1 mt-3">Status:</label>
                                                                                    <br />
                                                                                    <Select
                                                                                        options={optionsStatus}
                                                                                        defaultValue={filterStatus}
                                                                                        value={filterStatus}
                                                                                        onChange={(selected) => {
                                                                                            this.handleFilterChange(selected, "status");
                                                                                        }}
                                                                                        className="roFilter"
                                                                                        isMulti={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-12 d-flex justify-content-end mt-3">
                                                                                    <button
                                                                                        type="submit"
                                                                                        class="btn btn-primary"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            this.historyApi();
                                                                                        }}
                                                                                    >
                                                                                        {" "}
                                                                                        <i class="fa fa-check-circle"></i>Apply
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn ml-2 btn-primary"
                                                                                        onClick={() => {
                                                                                            this.resetFilter();
                                                                                        }}
                                                                                    >
                                                                                        <i class="mdi mdi-replay"></i>Reset
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* <div className='d-flex align-items-center mt-3 ml-3 search-adj'>
                                                                        <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                                                                        <Input
                                                                            onChange={this.handleChange}
                                                                            onBlur={this.handleTouch}
                                                                            value={form[formFields.search.key]}
                                                                            setting={formFields[formFields.search.key]}
                                                                            error={errors[formFields.search.key]}
                                                                            submited={submited}
                                                                        // disabled={true}
                                                                        // touched={touched[formFields.search.key]}
                                                                        />
                                                                    </div> */}
                                                                </div>
                                                                {IsAgency && advertiserId &&
                                                                    <div className="d-flex col-md-2 align-items-center justify-content-end position-absolute" style={{ right: 10 }}>
                                                                        <div className='badge badge-secondary text-dark'>{advertiserData.advertiserName}</div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </React.Fragment>

                                                        {
                                                            currentTableName === "Executed Recommendation" ?
                                                                <div className="optimiser-subsection-table campaign-list-adj table-responsive">
                                                                    <Table
                                                                        options={clonedOptions}
                                                                        data={historyData || []}
                                                                        handelAction={this.handleRecommedationAction}
                                                                    />

                                                                </div> :
                                                                <div className="optimiser-subsection-table campaign-list-adj table-responsive">
                                                                    <Table
                                                                        options={clonedHistoryColumns}
                                                                        data={historyData || []}
                                                                        handelAction={this.handleRecommedationAction}
                                                                    />

                                                                </div>

                                                        }
                                                    </Card>
                                                </div>
                                            </> : ''}
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        paymentAccess: get(state, 'app.paymentAccess.response', {}),
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getOptimizerListAction,
        getOptimizerListRecommendationAction,
        getPaymentRelatedAccessAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
};